import React, {useEffect} from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import WizardPopupContext, {useCustomContext, wizardPopupAction} from "../WizardPopupContext";
import {WIZARD_GROUP_TYPES} from "../../WizardItem/wizardItemInterface";
import WizardPopupInputsSortableItems from "./WizardPopupInputsSortableItems";
import {arrayMove} from "../../../../utilities";

const shouldCancelStart = (event) => {
  const excludedClassNames = ["ui-svg-checkbox__icon", "ui-svg-checkbox__text"];
  if (excludedClassNames.some(className => {
    return event.target.classList.contains(className) || event.target.closest("."+className)
  })) {
    return true
  }
};

export const allInputs = [
  {id: "firstName"}, // {id: "", checked:bool, required: bool, oneLine: false}
  {id: "lastName"},
  {id: "phone"},
  {id: "phone2"},
  {id: "email"},
  {id: "address"},
  {id: "city"},
  {id: "postal"},
  {id: "receiveSmsCheckbox"},
];

export const createReorderedInputsList = (fromInputs = []) => {
  let inputFields = [...fromInputs];
  allInputs.forEach(inputObject => {
    if (!inputFields.some(obj => obj.id === inputObject.id)) {
      inputFields.push(Object.assign({}, {id: inputObject.id}))
    }
  });
  return inputFields
}

const WizardPopupInputsGroup = (props) => {

  const {wizardPopupGroup} = props;

  const {wizardPopupState, wizardPopupDispatch} = useCustomContext(WizardPopupContext);

  const {inputFields} = wizardPopupState;

  useEffect(() => {

  }, []);

  const onSortStart = ({node}) => {
    const element = node.closest(".wizard-popup__drag");
    const currentIndex = element ? element.dataset.index : -1;
    window.draggingDiscountSection = +currentIndex;
  };

  const onSortEnd = ({ oldIndex, newIndex, collection}, e) => {

    if (oldIndex !== newIndex) {
      const newInputFields = arrayMove(inputFields, oldIndex, newIndex);
      // console.log("newInputFields", newInputFields);
      wizardPopupDispatch({
        type: wizardPopupAction,
        payload: {
          inputFields: newInputFields
        }
      });
    }
  };

  return (
    <div className={"wizard-popup" + (wizardPopupGroup.nodeType === WIZARD_GROUP_TYPES.custom ? " wizard-popup--custom" : "")}>
      <div className="wizard-popup__title">
        <h3>{wizardPopupGroup.customDisplayName || wizardPopupGroup.groupName} <FormattedMessage id="wizard.popup.editGroupTitle"/></h3>
      </div>
      <WizardPopupInputsSortableItems inputFields={inputFields}
                                      shouldCancelStart={shouldCancelStart}
                                      onSortEnd={onSortEnd}
                                      onSortStart={onSortStart}/>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {wizardPopupGroup} = store.wizardState;
  return {
    wizardPopupGroup,
  };
};

export default connect(mapStateToProps)(WizardPopupInputsGroup)
